export default "__VITE_ASSET__Bhlq0Kuz__"